import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { FileService } from '../../../../../core/services/file.service';
import { GraduationService } from '../../../../../core/services/graduation.service';
import { PdfService } from '../../../../../core/services/pdf.service';
import { ProfessorAcademicClassroomService } from '../../../../../core/services/professor-academic-classroom.service';
import { ProfessorService } from '../../../../../core/services/professor.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-professor-classroom',
    templateUrl: './professor-classroom.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./professor-classroom.component.css']
})
export class ProfessorClassroomComponent {
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  buttonsPermission :any|undefined;
 search_text=""
  professors:any[] =[]
  classrooms:any[] =[]
  selectedClassrooms:any[] =[]
  data:any[] =[]
  data2:any[] =[]
  selected_data:any;
  professor_id:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  cycleId:any
  loading=false
  tag="admin-professors-classrooms"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  classroomId:any
  fileInput:any
  pdfViewLoader=false
 

  constructor(
    private spinnerService:NgxSpinnerService,
    private pacService:ProfessorAcademicClassroomService,
    private classroomService:ClassroomService,
    private professorService:ProfessorService,
    private fileService:FileService,
    private toastrService:ToastrService,
    private lsService:LocalStorageService,
    private pdfService:PdfService,
    configCanvas: NgbOffcanvasConfig, 
    private offcanvasService: NgbOffcanvas,
      config: NgbModalConfig,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;

     configCanvas.position = 'end';
     configCanvas.backdropClass = 'bg-info';
     configCanvas.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
this.getActions()
  }

  init(){
    this.getAll()
    this.getClassrooms()
    this.getProfessors()
  
  }
  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des enseignants",err)

    })
  }

  getAll(){
    this.pacService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }
  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }
  getProfessors(){
    this.professorService.getAll().subscribe((res:any)=>{
      this.professors=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }

  loadProfessors(ev:any){
    this.classroomId=ev
    this.pacService.getAll(ev).subscribe((res:any)=>{
      this.data2=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }
  store(value:any){
    this.loading=true
    
    this.pacService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.selectedClassrooms=[]
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
  update(value:any){
    this.loading=true

    this.pacService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.pacService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
})
  }
  setPrincipal(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Enseignant principal','Voulez vous vraiment définir cet enseignant comme principal?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.pacService.setPrincipal({
      id:this.selected_data.id,
      classroomId:this.classroomId
    }).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.loadProfessors(this.classroomId)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
})
  }
  removeClassroom(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.pacService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
    this.professor_id=el.id
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }
  addFileContent(content:any){
    if(!this.verifyIfElementChecked()) return ;

    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.pacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des enseignants",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }

  async upload(event:any){
    if(event.target.files.length>0){
     this.fileInput=event.target.files[0]
    }
  } 
  getPage(event:any){
    this.pg.p=event
  }

  getPdf(){
    var professors:any[]=[];
    this.data.forEach((el:any)=> professors.push(el.id));
    this.pdfService.getProfessorClassroomsList(professors).subscribe((res:any)=>{
      console.log(res);
      
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
  },
  (err:any)=>{
    console.log(err)
      AppErrorShow.showError("Gestion des cours",err)

  })
  }

}
